import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomFieldsCoreModule } from "@webapp/custom-fields/custom-fields-core.module";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { ParentSelectorModule } from "@webapp/okrs/components/parent-selector/parent-selector.module";
import { PeopleSelectorModule } from "@webapp/shared/components/people-selector/people-selector.module";
import { IndicatorModule } from "@webapp/shared/indicator/indicator.module";
import { RichTextEditorModule } from "@webapp/shared/rich-text-editor/rich-text-editor.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiDatePickerModule } from "@webapp/ui/date-picker/date-picker.module";
import { UiDrawerModule } from "@webapp/ui/drawer/drawer.module";
import { UiDropdownModule } from "@webapp/ui/dropdown/dropdown.module";
import { UiFormModule } from "@webapp/ui/form/form.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiInputModule } from "@webapp/ui/input/input.module";
import { UiMenuModule } from "@webapp/ui/menu/menu.module";
import { UiSelectModule } from "@webapp/ui/select/select.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { CreateTaskComponent } from "./components/create-task/create-task.component";
import { JiraIssueIconComponent } from "./components/jira-icon/jira-icon.component";
import { TaskDetailsComponent } from "./components/task-details/task-details.component";

@NgModule({
  declarations: [JiraIssueIconComponent, CreateTaskComponent, TaskDetailsComponent],
  imports: [
    UiTooltipModule,
    UiGridModule,
    UiButtonModule,
    UiIconModule,
    UiDrawerModule,
    UiDropdownModule,
    UiMenuModule,
    FormsModule,
    ReactiveFormsModule,
    UiFormModule,
    UiInputModule,
    UiSelectModule,
    UiDatePickerModule,
    LocalizationModule,
    CommonModule,
    CustomFieldsCoreModule,
    RichTextEditorModule,
    IndicatorModule,
    PeopleSelectorModule,
    ParentSelectorModule,
  ],
  exports: [JiraIssueIconComponent, CreateTaskComponent, TaskDetailsComponent],
})
export class TasksModule {}
